import type {MemexColumnDataType, SystemColumnId} from '../../../api/columns/contracts/memex-column'
import {BaseColumnModel} from '../abstract/base'

export class ParentIssueColumnModel extends BaseColumnModel {
  declare readonly id: typeof SystemColumnId.ParentIssue
  declare readonly dataType: typeof MemexColumnDataType.ParentIssue
  declare readonly userDefined: false
}
